import { common } from '@kurtosys/ksys-app-template';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';
export abstract class QueryStore {
	abstract get executionOptions(): IExecutionOptions;
	abstract initialize(): Promise<void>;
	abstract query(options?: IQueryOptions, overrideExecutionOptions?: Partial<IExecutionOptions>): any;
	abstract mergeQueriesAndProps<T>(
		componentOrchestration?: { props?: any; queries?: any },
		responseContext?: any,
	): T | undefined;
	flattenProps(props?: { [key: string]: any }, keysToFlatten?: string[]) {
		if (props) {
			const response: any = (keysToFlatten || Object.keys(props || {})).reduce((acc: any, key) => {
				const value = props[key];
				if (value && common.commonUtils.isObject(value)) {
					if ((value as any)['queryOptionsType']) {
						acc[key] = this.query(value as any);
					} else {
						acc[key] = this.flattenProps(value);
					}
				} else {
					acc[key] = value;
				}
				return acc;
			}, {});
			return response;
		}
	}
}
